type PendoEventMetadata = Record<string, string | number | boolean | undefined>;

export const trackPendoEvent = (
  eventName: string,
  metadata?: PendoEventMetadata,
) => {
  if (typeof window === 'undefined' || !window.pendo?.track) {
    return;
  }

  window.pendo.track(eventName, metadata);
};
